export const checkboxTerms =
  'I accept the terms and conditions outlined in our La Mesa | RecVan <a class="underline" href="/privacy-policy">privacy policy</a>';
export const checkBoxSubscribe =
  'I want to stay informed on new arrivals get exclusive access to the best deals, featured specials, promotional manufacturer offer and special RV shows';
export const messageError = 'An error has occurred, please try again later or contact us using alternative methods';
export const messageSuccess = 'Thank you for Contacting Us!';
